import { useEffect, useState } from 'react';

/**
 * 사이트 콘텐츠를 API 에서 읽는다.
 * 실패하면 fallback(코드에 남겨둔 기존 데이터)을 쓴다 —
 * API 가 죽어도 화면이 비지 않게 하려는 것.
 */
export default function useSite(path, fallback) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(path)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive && d) setData(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, [path]);
  return data === null ? fallback : data;
}

// {ko,en} 이든 평문이든 현재 언어로 꺼낸다
export function pick(v, lang) {
  if (v && typeof v === 'object') return v[lang] || v.ko || '';
  return v || '';
}
